import { render, staticRenderFns } from "./flvVideo.vue?vue&type=template&id=61c25f6f&scoped=true"
import script from "./flvVideo.vue?vue&type=script&lang=js"
export * from "./flvVideo.vue?vue&type=script&lang=js"
import style0 from "./flvVideo.vue?vue&type=style&index=0&id=61c25f6f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c25f6f",
  null
  
)

export default component.exports